/* Gastrolux: preserve the option selector position across product size/coating changes, and confirm media refresh. */
(function(){
  const STORAGE_KEY='gwe:pdp:option-change';
  const TTL=15000;
  const root=document.querySelector('[data-section-type="product-template"]')||document.querySelector('.product-area');
  if(!root)return;
  let toastTimer=null;
  let pendingPhotoUntil=0;
  function toast(){
    let el=document.querySelector('.gwe-product-photo-toast');
    if(!el){
      el=document.createElement('div');
      el.className='gwe-product-photo-toast';
      el.setAttribute('role','status');
      el.setAttribute('aria-live','polite');
      el.innerHTML='<span class="gwe-product-photo-toast__check" aria-hidden="true">✓</span><span>Photo produit mise à jour</span>';
      document.body.appendChild(el);
    }
    const header=document.querySelector('#site-control');
    const headerBottom=header?header.getBoundingClientRect().bottom:0;
    el.style.setProperty('--gwe-photo-toast-top',Math.max(18,Math.min(window.innerHeight-65,headerBottom+12))+'px');
    clearTimeout(toastTimer);
    el.classList.remove('is-visible');
    requestAnimationFrame(()=>el.classList.add('is-visible'));
    toastTimer=setTimeout(()=>el.classList.remove('is-visible'),2200);
  }
  function remember(link){
    try{
      const next=new URL(link.href,location.href);
      if(next.origin!==location.origin||!next.pathname.startsWith('/products/')||next.pathname===location.pathname)return false;
      sessionStorage.setItem(STORAGE_KEY,JSON.stringify({path:next.pathname,at:Date.now()}));
      return true;
    }catch{return false}
  }
  document.addEventListener('click',event=>{
    const link=event.target.closest('.product-area .selector-wrapper.diametre-contenance a[href]');
    if(link&&remember(link))return;
    const control=event.target.closest('.product-area .selector-wrapper a[data-value],.product-area .selector-wrapper button[data-value]');
    const wrapper=control?.closest('.selector-wrapper');
    if(wrapper&&!/foyer|hob/i.test((wrapper.dataset.optionName||'')+' '+wrapper.className))pendingPhotoUntil=Date.now()+2400;
  },true);
  root.addEventListener('change',event=>{
    const wrapper=event.target.closest('.selector-wrapper');
    if(wrapper&&!/foyer|hob/i.test((wrapper.dataset.optionName||'')+' '+wrapper.className))pendingPhotoUntil=Date.now()+2400;
  });
  const media=root.querySelector('.product-area__media,.product-area__media-container,.product-area__images,[data-product-media]')||document.querySelector('.product-area__media');
  if(media){
    const observer=new MutationObserver(mutations=>{
      if(Date.now()>pendingPhotoUntil)return;
      const photoUpdated=mutations.some(m=>(m.type==='childList'&&m.addedNodes.length>0)||(m.type==='attributes'&&['src','srcset','class','style','aria-hidden','data-media-id'].includes(m.attributeName)));
      if(!photoUpdated)return;
      pendingPhotoUntil=0;
      toast();
    });
    observer.observe(media,{attributes:true,childList:true,subtree:true,attributeFilter:['src','srcset','class','style','aria-hidden','data-media-id']});
  }
  let pending=null;
  try{
    const raw=sessionStorage.getItem(STORAGE_KEY);
    pending=raw?JSON.parse(raw):null;
    if(pending&&Date.now()-pending.at>TTL){sessionStorage.removeItem(STORAGE_KEY);pending=null}
  }catch{}
  if(!pending||pending.path!==location.pathname)return;
  let restored=false;
  function restore(){
    if(restored)return;
    const select=document.querySelector('.product-area .selector-wrapper.diametre-contenance')||document.querySelector('.product-area .option-selectors .selector-wrapper');
    if(!select)return;
    restored=true;
    try{sessionStorage.removeItem(STORAGE_KEY)}catch{}
    requestAnimationFrame(()=>requestAnimationFrame(()=>{
      const header=document.querySelector('#site-control');
      const rect=header?.getBoundingClientRect();
      const headerHeight=rect?Math.max(0,Math.min(230,rect.height)):0;
      const scrollTop=Math.max(0,window.scrollY+select.getBoundingClientRect().top-headerHeight-20);
      window.scrollTo({top:scrollTop,behavior:'instant'});
      setTimeout(toast,350);
    }));
  }
  setTimeout(restore,150);
  window.addEventListener('load',restore,{once:true});
  window.addEventListener('pageshow',restore,{once:true});
})();
